module.exports = __webpack_public_path__ + "static/media/shimakaze-icon.6a06da32.png";